import type { LineaPresupuesto, Totales } from './types';

export function calcularTotales(lineas: LineaPresupuesto[]): Totales {
  let subtotal = 0;
  let totalDescuento = 0;

  // Agrupar IVA por tipo
  const ivaMap: Record<number, { base: number; cuota: number }> = {};

  for (const l of lineas) {
    const bruto = l.unidades * l.precioUnitario;
    const descImporte = bruto * (l.descuento / 100);
    const neto = bruto - descImporte;
    const cuotaIVA = neto * (l.iva / 100);

    subtotal += bruto;
    totalDescuento += descImporte;

    if (!ivaMap[l.iva]) ivaMap[l.iva] = { base: 0, cuota: 0 };
    ivaMap[l.iva].base += neto;
    ivaMap[l.iva].cuota += cuotaIVA;
  }

  const baseImponible = subtotal - totalDescuento;
  const gruposIVA = Object.entries(ivaMap).map(([tipo, v]) => ({
    tipo: Number(tipo),
    base: v.base,
    cuota: v.cuota,
  })).sort((a, b) => a.tipo - b.tipo);
  const totalIVA = gruposIVA.reduce((s, g) => s + g.cuota, 0);

  return {
    subtotal,
    totalDescuento,
    baseImponible,
    totalIVA,
    totalGeneral: baseImponible + totalIVA,
    gruposIVA,
  };
}

export function formatEUR(n: number): string {
  return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(n);
}

export function formatFecha(iso: string): string {
  return new Date(iso).toLocaleDateString('es-ES', {
    day: '2-digit', month: '2-digit', year: 'numeric',
  });
}

export function addDays(iso: string, days: number): string {
  const d = new Date(iso);
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
}

export function today(): string {
  return new Date().toISOString().slice(0, 10);
}

export function lineaVacia(): LineaPresupuesto {
  return {
    id: crypto.randomUUID(),
    descripcion: '',
    unidades: 1,
    precioUnitario: 0,
    descuento: 0,
    iva: 21,
  };
}
